import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import { request } from '../../_network/request'
import { clientAccountsURLs, alertsURLs } from '../../_network/apiUrls'
import { coreTypes } from './_common/notificationTypes'
import CustomBackdrop from '../_common/CustomBackdrop'
import CustomSelectField from '../_common/_form_fields/CustomSelectField'

const NotificationAdd = (props) => {
  const { setFetchAlerts, handleNotificationAddDialogClose, handleNotificationSentDialogOpen } = props
  const theme = useTheme()

  const account_id = useSelector(state => state.profile.account_id)

  const [username, setUsername] = useState(null)
  const [type, setType] = useState('')
  const [typeList, setTypeList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({})

  const fieldBoxStyle = {
    padding: '12px 0px'
  }

  const formControlStyle = {
    background: theme.palette.aliceBlue,
    color: theme.palette.vodka,
    borderRadius: '5px',
    width: '100%',
  }

  const outlinedInputStyle = {
    '& .MuiInputBase-input::label': {
      color: theme.palette.vodka,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
  }

  const errorHelperStyle = {
    color: theme.palette.coralRed,
    paddingLeft: '5px',
  }

  const saveButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.greenSheen,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    marginTop: '20px',
    textTransform: 'capitalize',

    '&:hover': {
      background: alpha(theme.palette.greenSheen, 0.8),
    },
  }

  const handleChangeType = (value) => {
    setType(value)

    if (value) {
      setErrors(prev => { return { ...prev, type: null } })
    }
  }

  const getRequestTitle = (type) => {
    const type_object = typeList.find(item => item.value === type)
    return type_object ? type_object.keyword : ''
  }

  const sendRequest = async (postData) => {
    const url = constants.core_service_domain + '/' + alertsURLs.getAlerts
      
    const request_data = { url, method: 'POST', data: postData }
    
    const response = await request(request_data)
    
    if (response && response.status_code && response.status_code < 400) {
      setFetchAlerts(prev => prev + 1)
      handleNotificationAddDialogClose()
      handleNotificationSentDialogOpen()
    }
  }

  const handleClickSubmit = async () => {
    setIsLoading(true)
    let _errors = {}

    if (!type) {
      _errors.type = defaultTexts.pleaseFillOut
    }

    if (Object.keys(_errors).length === 0) {
      const postData = {
        group: 'core',
        type,
        client_id: account_id,
        alert_data: {
          direction: 'send',
          username,
          request: getRequestTitle(type),
        }
      }
      
      await sendRequest(postData)      
    }

    setErrors(_errors)
    setIsLoading(false)
  }

  useEffect(() => {
    setTypeList(coreTypes.filter(item => item.send))
  }, [])

  useEffect(() => {
    const fetchProfileData = async () => {
      setIsLoading(true)

      const url = constants.core_service_domain + '/' + clientAccountsURLs.getProfile      
      const request_data = { url, method: 'GET' }    
      const response = await request(request_data)
      
      if (response && response.status_code && response.status_code < 400 && response.data) {
        setUsername(response.data.username)
      } else {
        setUsername(null)
      }

      setIsLoading(false)
    }

    fetchProfileData()
  }, [])

  return (
    <>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Box sx={fieldBoxStyle}>
        <CustomSelectField
          label={defaultTexts.notificationType}
          items={typeList} 
          currentValue={type}
          setCurrentValue={handleChangeType}
          required={true}
          error={errors.type ? true : false}
          loginHelperText={errors.type}
          loginHelperSx={errorHelperStyle}
          self_item_titles={true}
          size='small'
          sx={formControlStyle}
          outlinedInputSx={outlinedInputStyle}
        />
      </Box>

      <Stack
        direction='row'
        justifyContent='flex-end'
      >
        <Button
          variant='contained'
          disableRipple
          disableElevation
          disabled={false}
          onClick={handleClickSubmit}
          sx={saveButtonStyle}
        >
          {defaultTexts.send}
        </Button>
      </Stack>
    </>
  )
}

export default NotificationAdd